import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {withRouter} from 'react-router';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class ArticleTeaser extends Component {
  render() {
    return (
      <li className="col">
        <div className="blog_title">{this.props.name}</div>
        <img src={this.props.image} className="article_teaser_image"/>
        {this.props.source}
        <div className="blog_teaser">
           {this.props.teaser}
        </div>
        <Link to={`/blog/${this.props.id}`}>
              <Button className={Classes.MINIMAL}  text="Read Full Article  &raquo;" />
          </Link>
      </li>  
    );
  }
}

export default withRouter(ArticleTeaser);